export default "__VITE_ASSET__nw2l4Lc3__"